import { render, staticRenderFns } from "./Fechamento.vue?vue&type=template&id=49393aa1&scoped=true"
import script from "./Fechamento.vue?vue&type=script&lang=js"
export * from "./Fechamento.vue?vue&type=script&lang=js"
import style0 from "./Fechamento.vue?vue&type=style&index=0&id=49393aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49393aa1",
  null
  
)

export default component.exports